(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SurveyAnalyticsMongo", [], factory);
	else if(typeof exports === 'object')
		exports["SurveyAnalyticsMongo"] = factory();
	else
		root["SurveyAnalyticsMongo"] = factory();
})(this, () => {
return 